import { render, staticRenderFns } from "./correct.vue?vue&type=template&id=857f78b0&scoped=true&"
import script from "./correct.vue?vue&type=script&lang=js&"
export * from "./correct.vue?vue&type=script&lang=js&"
import style0 from "./correct.vue?vue&type=style&index=0&id=857f78b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857f78b0",
  null
  
)

export default component.exports